import React, { useState } from "react";
import { Menu, X } from "lucide-react";

// Layout Admin : sidebar sombre à gauche (desktop) + barre déroulante (mobile).
// Structure conforme à l'image « Backend Admin — Structure et écrans principaux ».
export const AdminLayout = ({ items, active, onSelect, header, children }) => {
  const [open, setOpen] = useState(false);
  const select = (k) => { onSelect(k); setOpen(false); };
  return (
    <div className="flex min-h-[calc(100vh-64px)]">
      {/* Sidebar desktop */}
      <aside className="hidden lg:flex w-56 shrink-0 flex-col bg-[#0F1E33] text-white" data-testid="admin-sidebar">
        <nav className="flex-1 py-4">
          {items.map((it) => (
            <button key={it.key} type="button" data-testid={`menu-${it.key}`} onClick={() => select(it.key)}
              className={`w-full flex items-center gap-2.5 px-4 py-2.5 text-sm font-semibold text-left transition-colors ${
                active === it.key ? "bg-[#FF6600] text-white" : "text-white/70 hover:bg-white/10 hover:text-white"}`}>
              <it.icon className="h-4 w-4 shrink-0" /> {it.label}
            </button>
          ))}
        </nav>
        <div className="px-4 py-3 text-[10px] uppercase tracking-wider text-white/40 border-t border-white/10">Colis2Go — Administration</div>
      </aside>

      {/* Contenu */}
      <div className="flex-1 min-w-0">
        {/* Menu mobile */}
        <div className="lg:hidden sticky top-16 z-30 bg-[#0F1E33] text-white">
          <button type="button" data-testid="admin-mobile-menu-btn" onClick={() => setOpen(!open)}
            className="w-full flex items-center justify-between px-4 py-2.5 text-sm font-bold">
            <span className="flex items-center gap-2">
              {open ? <X className="h-4 w-4" /> : <Menu className="h-4 w-4" />}
              {items.find((i) => i.key === active)?.label || "Menu"}
            </span>
            <span className="text-[10px] uppercase tracking-wider text-white/50">Admin</span>
          </button>
          {open && (
            <nav className="border-t border-white/10 pb-2" data-testid="admin-mobile-menu">
              {items.map((it) => (
                <button key={it.key} type="button" data-testid={`mmenu-${it.key}`} onClick={() => select(it.key)}
                  className={`w-full flex items-center gap-2.5 px-4 py-2.5 text-sm font-semibold text-left ${
                    active === it.key ? "bg-[#FF6600] text-white" : "text-white/70"}`}>
                  <it.icon className="h-4 w-4" /> {it.label}
                </button>
              ))}
            </nav>
          )}
        </div>
        <div className="px-4 sm:px-6 py-6">
          {header}
          {children}
        </div>
      </div>
    </div>
  );
};
